import {
  SelectCellWithIcon,
  SelectCellWithIconConfig,
  SelectCellWithIconProps,
} from '@components/table';
import { OrderStatus, OrderStatusString } from '@features/halalShop/types';

import {
  AlarmIcon,
  CheckCircleOutlinedIcon,
  ClockIcon,
  CoinIcon,
  MinusCircleIcon,
  ProhibitIcon,
  ReceiptIcon,
  TruckIcon,
  WalletIcon,
} from '@packages/icons';
import { colors } from '@packages/uiKit';
import { FC, memo, useCallback } from 'react';

export interface OrderStatusCellProps
  extends Omit<SelectCellWithIconProps<OrderStatus>, 'config' | 'value'> {
  status: OrderStatus;
  onChange: (value: OrderStatus) => void;
}

const config: SelectCellWithIconConfig<OrderStatus> = [
  {
    value: OrderStatus.Canceled,
    label: OrderStatusString.Canceled,
    bgColor: colors.gray0,
    color: colors.white,
    icon: <ProhibitIcon />,
  },
  {
    value: OrderStatus.All,
    label: OrderStatusString.All,
    bgColor: colors.gray0,
    color: colors.white,
    icon: <MinusCircleIcon />,
  },

  {
    value: OrderStatus.Complete,
    label: OrderStatusString.Complete,
    bgColor: colors.primary,
    color: colors.white,
    icon: <CheckCircleOutlinedIcon />,
  },
  {
    value: OrderStatus.Error,
    label: OrderStatusString.Error,
    bgColor: colors.red1,
    color: colors.white,
    icon: <ProhibitIcon />,
  },
  {
    value: OrderStatus.New,
    label: OrderStatusString.New,
    bgColor: colors.red1,
    color: colors.white,
    icon: <AlarmIcon />,
  },
  {
    value: OrderStatus.NotPaid,
    label: OrderStatusString.NotPaid,
    bgColor: colors.warning,
    color: colors.dark1,
    icon: <WalletIcon />,
  },
  {
    value: OrderStatus.Paid,
    label: OrderStatusString.Paid,
    bgColor: colors.primary,
    color: colors.white,
    icon: <CheckCircleOutlinedIcon />,
  },
  {
    value: OrderStatus.PaymentProcess,
    label: OrderStatusString.PaymentProcess,
    bgColor: colors.warning,
    color: colors.dark1,
    icon: <CoinIcon />,
  },
  {
    value: OrderStatus.RefundIssued,
    label: OrderStatusString.RefundIssued,
    bgColor: colors.gray1,
    color: colors.white,
    icon: <ReceiptIcon />,
  },
  {
    value: OrderStatus.Returned,
    label: OrderStatusString.Returned,
    bgColor: colors.dark1,
    color: colors.white,
    icon: <CheckCircleOutlinedIcon />,
  },
  {
    value: OrderStatus.WaitConfirmation,
    label: OrderStatusString.WaitConfirmation,
    bgColor: colors.blue,
    color: colors.white,
    icon: <ClockIcon />,
  },
  {
    value: OrderStatus.WaitTake,
    label: OrderStatusString.WaitTake,
    bgColor: colors.warning,
    color: colors.dark1,
    icon: <TruckIcon />,
  },
];

const _OrderStatusCell: FC<OrderStatusCellProps> = (props) => {
  const { status, onChange, ...restProps } = props;

  const clickHandler: React.MouseEventHandler<HTMLDivElement> = useCallback(
    (e) => {
      e.stopPropagation();
    },
    [],
  );

  return (
    <SelectCellWithIcon
      config={config}
      value={status}
      onClick={clickHandler}
      onChange={onChange}
      {...restProps}
    />
  );
};

export const OrderStatusCell = memo(_OrderStatusCell);
